import React from 'react';
import { Medal1, Medal2, Medal3 } from '../../UI/icons';
import { formatHide } from '../../utils/common';
import './index.css';
const TopUser = ({ rank, user }) => {
  return (
    <div className={rank === 1 ? 'topuser1' : 'topuser2'}>
      <div className='username'>{`Top ${rank}: ${user?.name}`}</div>
      <div className='medal'>
        {rank === 1 ? <Medal1 /> : rank === 2 ? <Medal2 /> : <Medal3 />}
      </div>
      <div
        style={{
          padding: '24px 16px',
        }}>
        <table className='info-user'>
          <tr className='info-user-th'>
            <td>Số điện thoại</td>
            <td>Hạng</td>
            <td>Số User giới thiệu</td>
          </tr>
          <tr className='info-user-td'>
            <td>{formatHide(user?.phone, 3)}</td>
            <td>{user?.rank}</td>
            <td>{user?.invite_count}</td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default TopUser;
